import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Target.svg",
  "use": "Target.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Target.svg\"><path d=\"M32,56A24,24,0,1,1,56,32,24,24,0,0,1,32,56Zm0-42A18,18,0,1,0,50,32,18,18,0,0,0,32,14Zm0,32A14,14,0,1,1,46,32,14,14,0,0,1,32,46Zm0-22a8,8,0,1,0,8,8A8,8,0,0,0,32,24Zm0,12a4,4,0,1,1,4-4A4,4,0,0,1,32,36Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol